import TangramOptions from "./TangramOptions";
import Tangrams from "./Tangrams"
import { useEffect, useState } from "react";

export default function Level2_Tangrams(props) {
  return(
  <Tangrams {...props} plevel="Level1" img="House" progression={false}></Tangrams>
  )
}

